import { useMemo } from 'react';
import matchingPalette from '../data/matching-palette.json';

export function useClusterData() {
  return useMemo(() => {
    return matchingPalette.colors.map((color, index) => {
      return {
        cluster: index,
        color,
        radius: Math.sqrt(
          ((index + 1) / matchingPalette.colors.length) *
            -Math.log(Math.random())
        ),
        x:
          Math.cos((index / matchingPalette.colors.length) * 2 * Math.PI) * 300,
        y:
          Math.sin((index / matchingPalette.colors.length) * 2 * Math.PI) * 300,
        z: 0,
      };
    });
  }, []);
}
